/* RING KONG - fighter hero
   Reads the .rk-hero-mount div in the article body, finds the Shopify
   featured image, and builds the black panel, the scrolling name and
   the record around it. Styling lives in theme.css.
   Loaded once per visitor and cached. Never inline this in a post. */
(function () {
  function esc(v) {
    return String(v || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function build() {
    if (document.querySelector('.rk-hero__record')) return;

    var mount = document.querySelector('.rk-hero-mount');
    if (!mount) return;

    // The featured image is the first content image outside the post body
    var scope = document.querySelector('main') || document.body;
    var imgs = scope.querySelectorAll('img');
    var img = null;

    for (var i = 0; i < imgs.length; i++) {
      var c = imgs[i];
      if (c.closest('header, nav, footer, .article__content')) continue;
      if (c.width && c.width < 200) continue;
      img = c;
      break;
    }
    if (!img) return;

    var wrap = img.parentElement;
    while (wrap && (wrap.tagName === 'PICTURE' || wrap.tagName === 'A')) {
      wrap = wrap.parentElement;
    }
    if (!wrap) return;

    wrap.classList.add('rk-hero');
    img.classList.add('rk-hero__img');

    var d = mount.dataset;
    var nick = d.nick
      ? '<span class="rk-hero__word rk-hero__word--fill">&ldquo;' + esc(d.nick) + '&rdquo;</span>'
      : '';
    var unit =
      '<span class="rk-hero__name">' +
        '<span class="rk-hero__word rk-hero__word--outline">' + esc(d.first) + '</span>' +
        nick +
        '<span class="rk-hero__word rk-hero__word--outline">' + esc(d.last) + '</span>' +
      '</span>';

    var frag = document.createElement('div');
    frag.innerHTML =
      '<div class="rk-hero__marquee" aria-hidden="true">' +
        '<div class="rk-hero__track">' + unit + unit + '</div>' +
      '</div>' +
      '<span class="rk-hero__record" aria-hidden="true">' +
        '<span class="rk-hero__record-figure">' + esc(d.record) + '</span>' +
        '<span class="rk-hero__record-label">' + esc(d.note) + '</span>' +
      '</span>';

    while (frag.firstChild) wrap.insertBefore(frag.firstChild, wrap.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);
})();